 // const API_URL='http://192.168.31.23:8081'//基本路径
 // const API_BASE_URL='http://192.168.31.6:8085'//测试
 // const API_BASE_URLE='http://192.168.31.23'// 快速下单模板

// const API_URL='http://192.168.31.23:8081'// 测试环境
// const API_BASE_URL='http://192.168.31.23:8085'//测试
// const API_BASE_URLE='http://192.168.31.23' //测试环境

// const API_URL='http://cjmall.pingwaytech.com/searchApi'//搜索路径 线上环境
// const API_BASE_URL='http://cjmall.pingwaytech.com/portalApi'//基本路径 线上环境
// const API_BASE_URLE='http://cjmall.pingwaytech.com'//快速下单模板

 const API_URL='http://www.azlmro.com/searchApi'//交付搜索路径 线上环境
 const API_BASE_URL='http://www.azlmro.com/portalApi'//交付基本路径 线上环境
 const API_BASE_URLE='http://www.azlmro.com/'//交付快速下单模板


const requestUrl={
    register:API_BASE_URL+'/sso/register',//注册
    login:API_BASE_URL+'/sso/login',//登录账号密码
    // loginOut:API_BASE_URL+'/sso/logout',//登出
    loginOut:API_BASE_URL+'/member/logout',//登出
    loginBuyPhone:API_BASE_URL+'/sso/loginByCode',//手机号验证码登录
    retrievePassword:API_BASE_URL+'/sso/retrievePassword',//找回密码
    getSmsCode:API_BASE_URL+'/sso/getSmsCode',//获取手机验证码
    getUserInfo:API_BASE_URL+'/member/info',//获取用户信息 

    updateMemberInfo:API_BASE_URL+'/member/updateMemberInfo',//更新用户基本信息
    
    getInvoice:API_BASE_URL+'/invoice/findList',//获取发票信息
    getCaptcha:API_BASE_URL+'/sso/captcha.jpg',//获取图形验证码
    // 个人中心--安全中心
    updatePassword:API_BASE_URL+'/member/updatePassword',//修改密码
    updatePhone:API_BASE_URL+'/member/updatePhone',//修改手机号
    creatOrUpdateEmail:API_BASE_URL+'/member/creatOrUpdateEmail',//绑定/修改邮箱
    // 个人中心--我的收藏
    findPage:API_BASE_URL+'/member/findPage',//收藏列表
    addCart:API_BASE_URL+'/cart/insertOrUpdateList',//添加到购物车
    deleteProduc:API_BASE_URL+'/member/deleteProduct',//个人中心里删除收藏的商品
    buyNow:API_BASE_URL+'/order/buyNow',//立即购买
    // 个人中心--我的订单
    findPageOrderList:API_BASE_URL+'/memberOrder/findPageOrderList',//根据订单状态获取订单列表
    loadOrderDetails:API_BASE_URL+'/memberOrder/loadOrderDetails',//根据id查询订单详情
    cancelOrder:API_BASE_URL+'/memberOrder/cancelOrder',//取消订单
    deleteOrder:API_BASE_URL+'/memberOrder/delete',//删除订单
    updateOrder:API_BASE_URL+'/memberOrder/updateOrder',//修改订单
    findLogistics:API_BASE_URL+'/memberOrder/findLogistics',//查看物流
    updateOrderStatus:API_BASE_URL+'/memberOrder/updateOrderStatus',//确认收货
    createReturn:API_BASE_URL+'/memberOrder/createReturn',//申请售后
    returnReasonList:API_BASE_URL+'/memberOrder/returnReasonList',//退货的所有原因
    payOrderBuy:API_BASE_URL+'/memberOrder/goToPay',//我的订单购买
    returnOrderBuy:API_BASE_URL+'/returnApply/findpage',//售后列表
    updateDelivery:API_BASE_URL+'/returnApply/updateDelivery', //物流信息
    ossUpload:API_BASE_URL+'/PmsFileUpload/ossUpload',//上传图片


    // 个人中心--通知设置
    notic:API_BASE_URL+'/member/notic',

    getProductDetail:API_BASE_URL+'/home/queryProductInfo',//获取商品详情
    similarProductDetail:API_URL+'/esProduct/recommend/',//同类商品推荐
    addcollection:API_BASE_URL+'/cart/createProduct',//添加收藏

    orderPayWx:API_BASE_URL+'/order/orderPayWx',//微信支付
    orderPayAli:API_BASE_URL+'/order/orderPayAli',//支付宝支付
    orderPayBank:API_BASE_URL+'/order/orderPayUnion',//银联支付

    queryHomeCategory:API_BASE_URL+'/home/queryHomeCategory',
    homefloor:API_BASE_URL+'/home/list',//楼层获取
    homefloorImg:API_BASE_URL+'/home/imageList',//图片楼层
    advertiseList:API_BASE_URL+'/home/advertiseList',//轮播
    article: API_BASE_URL+'/home/queryPaperContentForHome',//文章查询
    articlelist: API_BASE_URL+'/home/queryPaperContentList',//文章列表
    queryPaperContent: API_BASE_URL+'/home/queryPaperContent',//根据id查询文章
    queryEsGoods:API_URL+'/esProduct/search/queryEsGoods',//商品查询
    searchinfo:API_URL+'/esProduct/search/searchCJRelatedInfo',//查找信息
    brandlist:API_BASE_URL+'/home/brandList',//查询所有品牌
    showbrand: API_URL+'/esProduct/search/queryBrandIds',//品牌展示
    type:API_URL+'/esProduct/search/queryEsGoodCategory',//二级分类
    createcost: API_BASE_URL+'/UmsCompanyCost/createCost',//成本中心管理

    findListCompanyCost:API_BASE_URL+'/UmsCompanyCost/findList',//查找所有成本中心

    // department:API_BASE_URL+'/department/list',//查找所有的部门
    updatecost:API_BASE_URL+'/UmsCompanyCost/updateCost',//修改成本中心
    deletecost:API_BASE_URL+'/UmsCompanyCost/deleteCost',//删除成本中心
    departmentadd: API_BASE_URL+'/department/add',//添加部门
    departmentlist: API_BASE_URL+'/department/list',//查询部门
    departmentremove: API_BASE_URL+'/department/remove',//删除部门
    departmentedit:API_BASE_URL+'/department/edit',//编辑部门
    queryrole:API_BASE_URL+'/umsCompanyController/queryMemberRole',//查询角色
    companyinfo:API_BASE_URL+'/umsCompanyController/getCompanyInfo',//查看公司详情
    companyupdate:API_BASE_URL+'/umsCompanyController/updateCompany',//修改公司信息


    memberadd: API_BASE_URL+'/umsCompanyController/addCompanyMember',//成员添加
    memberupdate: API_BASE_URL+'/umsCompanyController/updateCompanyMember',//修改成员信息
    memberlist: API_BASE_URL+'/umsCompanyController/queryCompanyMemberList',//成员所有信息
    getAllapproval: API_BASE_URL+'/umsCompanyController/approvalCompanyMemberList',//查询所有审批员
    MemberPassword:API_BASE_URL+'/umsCompanyController/resetCompanyMemberPassword',//重置密码
    memberdelete: API_BASE_URL+'/umsCompanyController/deleteCompanyMember',//禁用
    delCompanyMember:API_BASE_URL+'/umsCompanyController/delCompanyMember',//删除账户
    createapproval:API_BASE_URL+"/companyApproval/createApproval",//审批流新增
    findlist:API_BASE_URL+'/companyApproval/findList',//查询审批流程
    updateappro: API_BASE_URL+'/companyApproval/updateApproval',//编辑审批流程
    deleteapproval: API_BASE_URL+'/companyApproval/deleteApproval',//删除审批流程
    invoiceLoadById:API_BASE_URL+'/invoice/loadById',//发票信息详情
    

    //统计分析
    orderStatistics:API_BASE_URL+'/umsCompanyController/orderStatistics', //公司订单统计
    deptStatistics:API_BASE_URL+'/umsCompanyController/deptStatistics', //公司部门采购
    memberStatistics:API_BASE_URL+'/umsCompanyController/memberStatistics', //公司人员采购
    // 购物车
    cartList:API_BASE_URL+'/cart/list/promotion',//购物车列表
    updateCount:API_BASE_URL+'/cart/update/quantity',//修改购物车中某一商品数量
    cartsize:API_BASE_URL+'/cart/size', //购物车商品类型数量
    deleteCart:API_BASE_URL+'/cart/delete',//删除购物车
    confirmOrder:API_BASE_URL+'/order/generateConfirmOrder',//确认订单
    confirmPay:API_BASE_URL+'/order/generateOrder',//确认订单付款
    //收货地址
    allAddress:API_BASE_URL+'/member/address/addressList',//收货地址
    newAddAddress:API_BASE_URL+'/member/address/add',//新增收货地址
    deleteAddress:API_BASE_URL+'/member/address/delete',//删除收货地址
    updateAddress:API_BASE_URL+'/member/address/update',//修改地址
    //发票
    invoiceList:API_BASE_URL+'/invoice/findList',//发票信息
    addinvoice:API_BASE_URL+'/invoice/createInvoice',//新增发票
    updateInvoice:API_BASE_URL+'/invoice/updateInvoice',//修改发票信息
    deleteInvoice:API_BASE_URL+'/invoice/deleteInvoice',//删除发票
    //invoiceLoadById:API_BASE_URL+'/invoice/loadById',//发票信息详情

    //审批
    purchaseList:API_BASE_URL+'/approvalOrder/findListByStatusToBuyer',//待审批
    // approvalList:API_BASE_URL+'/approvalOrder/findListByStatusToApproval',//审批员待审批单
    // purchaseList:API_BASE_URL+'/approvalOrder/findListByStatusToApproval',//待审批
    approvalState:API_BASE_URL+'/approvalOrder/updateProcessOrder',//审批状态
    approvalAll:API_BASE_URL+'/approvalOrder/findListAdopt',//历史审批单
    exportExcel:API_BASE_URL+'/orderDeliveryRecord/exportExcel',//管理员导出excel
    queryAllByLimit: API_BASE_URL+'/orderDeliveryRecord/queryAllByLimit',//查询发货记录
    exportHistoryExcel:API_BASE_URL+'/approvalOrder/companyOrderExportExcel',//审批历史导出
    ApprovalMessage:API_BASE_URL+'/approvalOrder/findListOrderSnToApproval',//审批订单提醒
    //查询协议商品
    protocolGoods:API_BASE_URL+'/protocolProduct/selectByProtocol',//查询协议商品
    quickorder:API_BASE_URL+'/cart/fastInsertList',//快速下单添加购物车
    quickTemplateorder:API_BASE_URLE+'/Cj-File/快速下单导入模板.xlsx',//快速下单模板
    addCartBuyExcel:API_BASE_URL+'/cart/importExcel',//上传excel

    
    

    
}
export default requestUrl;


// WEBPACK FOOTER //
// ./src/utils/requestApi.js